module.exports = {
	getNumber : function(){
		return Math.round(Math.random() * new Date());
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/randomness.js
// module id = 13
// module chunks = 0 1 2